// 拆解網址，並將參數轉換為物件(需要支援 ${xxx} 的參數)
// 例如：https://www.google.com/${bot_id}?q=test&page=1&bot_id=${bot_id}
// 轉換後為：{ strUrl: 'https://www.google.com/${bot_id}', searchParams: { q: 'test', page: '1', bot_id: '${bot_id}' } }

export function splitUrl(oriUrl: string) {
  const url = oriUrl.split('?')[0];
  const searchParams = oriUrl.split('?')[1];
  const searchParamsObj = new URLSearchParams(searchParams);

  return {
    url,
    searchParams: Object.fromEntries(searchParamsObj.entries()),
  };
}
